import { CGame } from "./CGame";
import { CByteArray } from "./CByteArray";

export class CDiceSP {
    private m_mcs:Array<fgui.GMovieClip>;
    private m_Val:CByteArray;
    private m_Callback:Function;

    constructor() {
        this.m_mcs = new Array<fgui.GMovieClip>(3);
        this.m_Val = new CByteArray(3);
        this.m_Callback = null;
    }

    public Init(parent:fgui.GComponent):boolean {
        for( let i = 0; i < 3; i ++ ) {
            let mc = parent.getChild("mc_Dice"+i) as fgui.GMovieClip;
            mc.playing = false;
            mc.visible = false;
            this.m_mcs[i] = mc;
        }
        return true;
    }

    public Stop():boolean {
        for( let i = 0; i < 3; i ++ ) {
            this.m_mcs[i].visible = false;
            this.m_mcs[i].playing = false;
        }
        return true;
    }

    public Start(val:CByteArray, dm:number, callback:Function):void {
        this.m_Val[0] = val[0];
        this.m_Val[1] = val[1];
        this.m_Val[2] = val[2];
        for( let i = 0; i < 3; i ++ ) {
            this.m_mcs[i].frame = CGame.GetRand(0, 12);
            this.m_mcs[i].visible = true;
            this.m_mcs[i].playing = true;
        }
        this.m_Callback = callback;
        var that = this;
        createjs.Tween.get(this.m_mcs[0])
                            .wait(dm)
                            .call(function() {
                                for( let i = 0; i < 3; i ++ ) {
                                    that.m_mcs[i].frame = (that.m_Val[i]-1) * 2;
                                    that.m_mcs[i].playing = false;
                                }
                            })
                            .wait(1000)
                            .call(function() {
                                for( let i = 0; i < 3; i ++ ) {
                                    that.m_mcs[i].visible = false;
                                }
                                //console.log("End Dice:", that.m_Callback);
                                if( that.m_Callback ) {
                                    that.m_Callback();
                                    that.m_Callback = null;
                                }
                            });
    }
}